import { apiClient } from "../lib/apiClient";

interface AnalyticsAccessResponse {
  has_access: boolean;
}

/**
 * Check if the current user has access to analytics.
 * Email list is maintained in the backend at:
 * backend/app/controllers/auth_controller.py (ANALYTICS_ALLOWED_EMAILS)
 *
 * To add more emails, edit that list in the backend.
 */
export const checkAnalyticsAccess = async (): Promise<boolean> => {
  try {
    const response = await apiClient<AnalyticsAccessResponse>("/auth/analytics-access");
    return response.has_access;
  } catch {
    return false;
  }
};
